export const E_CHARTS = 'echarts'
